import React, { useState, useContext } from 'react'
import turf from '@turf/area'
import { polygon } from '@turf/helpers'

import Grow from '@material-ui/core/Grow'
import Tooltip from '@material-ui/core/Tooltip'

import { LayerContext } from '../../data/AppContext'
// import { LayerContext } from '../data/AppContext'
import ClearLogo from '../../../../assets/eraser-tool.png'
import LogoArea from '../../../../assets/shape.png'
import './area.css'

function Area(props) {
  const [toggle, setToggle] = useState(false)
  const [values, setValues] = useState({ km: true, m2: false, ha: false })

  // const printDistance= ()=>{
  //   // const total=  area.concat([area[0]])
  //     setArea(turf(polygon([area]))/1*Math.pow(10, -6));
  //   // console.log(turf(polygon([[[125, -15], [113, -22], [154, -27], [144, -15], [125, -15]]])))
  // }

  return (
    <Grow in={props.menu[1].view}>
      <div className="ruler-menu">
        <div className="ruler-lbl-container">
          <label className="distance-txt">
            {values.km
              ? Intl.NumberFormat('en-US').format((props.lbl.toFixed(2) / 1) * Math.pow(10, -6)) + '  km2'
              : values.m2
              ? Intl.NumberFormat('en-US').format(props.lbl.toFixed(2)) + '  m2'
              : values.ha
              ? Intl.NumberFormat('en-US').format(props.lbl.toFixed(2) / 10000) + '  ha'
              : null}
          </label>
        </div>
        <button className="ruler-btn" onClick={() => setValues({ km: false, m2: true, ha: false })}>
          m2
        </button>
        <button className="ruler-btn" onClick={() => setValues({ km: true, m2: false, ha: false })}>
          km2
        </button>
        <button className="ruler-btn" onClick={() => setValues({ km: false, m2: false, ha: true })}>
          ha
        </button>
        <button
          className="ruler-btn"
          onClick={() => {
            props.delete()
            props.setPointer('Area Tool', true)
          }}
        >
          {' '}
          <img src={ClearLogo} className="icon-align-inf" />{' '}
        </button>
      </div>
    </Grow>
  )
}

export default Area
